module.exports = __webpack_public_path__ + "static/sin_datos-509c6c7535ad1e360b1e913555826c7a.svg";